<template>
  <div class="doc-wrapper">
    <spinner :show="loading" class="content-spinner d-flex flex-column"/>
    <redoc-wrapper :spec-or-spec-url="data" v-if="!loading && data"
                   :options="redocOptions"></redoc-wrapper>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import RedocWrapper from '@hnluu8/vue-redoc-wrapper'
import Spinner from "@/core/components/common/Spinner.vue";

const {mapActions, mapState} = createNamespacedHelpers('docs');
export default {
  name: "Redoc",
  components: {Spinner, RedocWrapper},
  methods: {
    ...mapActions(['loadData']),
  },
  computed: {
    ...mapState({
      loading: state => state.loading,
      data: state => state.data,
    })
  },
  data() {
    return {
      redocOptions: {
        hideDownloadButton: false,
        jsonSampleExpandLevel: 'all',
        theme: {
          xLogo: 'https://media.artisioauctions.com/artisio/horizontal_logo.png',
          sidebar: {
            backgroundColor: '#626E80',
            textColor: '#ffffff'
          }
        }
      },
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>

<style lang="scss" scoped>
@import "./scss/variables.scss";

.doc-wrapper {
  width: 100%;
  height: 100%;
  margin: 0 8px;
}

</style>
